export default "__VITE_ASSET__CLWb6rSp__"